import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function getKategoriLayanan() {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/kategorilayanan`, config);
  return data;
}

export async function getPaketLayanan(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/paketlayanan/getpaket`, body, config);
  return data;
}

export async function upsertKategoriLayanan(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/kategorilayanan`, body, config);
  return data;
}
